export default function App() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-16">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">移动访问入口</h2>
              </div>
              <p className="text-foreground-500 text-sm md:text-base mb-4 ml-4">随时随地，手机浏览器直接访问</p>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 ml-4">
                黑料吃瓜全平台采用响应式设计，无需下载任何APP，通过手机浏览器输入本站域名即可获得流畅的浏览体验。
                支持iOS Safari、Android Chrome等主流移动浏览器，随时随地追踪最新爆料动态。
              </p>
              <div className="flex flex-col sm:flex-row gap-3 ml-4">
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-200 rounded-lg">
                  <i className="ri-apple-line text-lg text-foreground-600"></i>
                  <span className="text-sm text-foreground-700 font-medium">iOS Safari 兼容</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-200 rounded-lg">
                  <i className="ri-android-line text-lg text-foreground-600"></i>
                  <span className="text-sm text-foreground-700 font-medium">Android Chrome 兼容</span>
                </div>
              </div>
            </div>
            <div className="flex-1 w-full lg:w-auto p-6 md:p-8 flex justify-center">
              <div className="relative w-[220px] h-[440px] bg-background-800 rounded-[32px] border-4 border-background-700 overflow-hidden">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-6 bg-background-700 rounded-b-xl z-10"></div>
                <div className="w-full h-full p-3 pt-10 flex flex-col gap-2">
                  <div className="h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                    <span className="text-white text-[10px] font-bold">黑料吃瓜</span>
                  </div>
                  <div className="flex-1 flex flex-col gap-2">
                    <div className="h-10 bg-background-600 rounded-lg"></div>
                    <div className="h-10 bg-background-600 rounded-lg"></div>
                    <div className="h-10 bg-background-600 rounded-lg"></div>
                    <div className="h-20 bg-background-600 rounded-lg"></div>
                    <div className="h-20 bg-background-600 rounded-lg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}